import { render, staticRenderFns } from "./InfoForm.vue?vue&type=template&id=4f93094f&scoped=true"
import script from "./InfoForm.vue?vue&type=script&lang=js"
export * from "./InfoForm.vue?vue&type=script&lang=js"
import style0 from "./InfoForm.vue?vue&type=style&index=0&id=4f93094f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f93094f",
  null
  
)

export default component.exports